import React from "react";
import { TApiSubset } from "../../../../../api/endpoints/Subset";
import { formatSubsetLabel } from "../../../../../utils/Format";
import SubsetTypes from "../../../../../utils/SubsetTypes";

interface Props {
  subset: TApiSubset;
}

const SubsetInfo = (props: Props) => {
  const { subset } = props;

  return (
    <h4 className="subset-info">
      <span>{formatSubsetLabel(subset)}</span>
      <div className="badge badge-secondary">{SubsetTypes.humanize(subset.type)}</div>
    </h4>
);
}

export default SubsetInfo;
